import SubscriptionRequestHistoryContainer from "./SubscriptionRequestHistoryContainer";

export default SubscriptionRequestHistoryContainer;